import { FiUsers, FiCamera, FiZap, FiBarChart2 } from "react-icons/fi";
import useScrollReveal from "../hooks/useScrollReveal";

const features = [
  {
    icon: <FiUsers size={16} />,
    text: "Grow the Vupop community",
  },
  {
    icon: <FiCamera size={16} />,
    text: "Help more fans share their moments",
  },
  {
    icon: <FiZap size={16} />,
    text: "Earn from successful referrals",
  },
  {
    icon: <FiBarChart2 size={16} />,
    text: "Track your referral performance directly in the app",
  },
];

const WhyPrefer = () => {
  const [labelRef, labelVisible] = useScrollReveal(0.1);
  const [headRef, headVisible] = useScrollReveal(0.1);

  return (
    <section className="px-10 sm:px-4 pb-16 sm:pb-10 mx-auto w-full">
      {/* Eyebrow */}
      <div
        ref={labelRef}
        className={`transition-all duration-700 ease-out ${
          labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        }`}
      >
        <p className="text-[rgba(255,255,255,0.45)] text-xs font-semibold tracking-widest uppercase font-League_Spartan mb-2">
          WHY PREFER
        </p>
      </div>

      {/* Heading */}
      <div
        ref={headRef}
        className={`transition-all duration-700 delay-100 ease-out ${
          headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        }`}
      >
        <h2 className="font-[Norwester]  text-white uppercase text-3xl sm:text-2xl mb-8 sm:mb-5">
          Built for creators and fans
        </h2>
      </div>

      {/* Feature grid */}
      <div className="grid grid-cols-2 sm:grid-cols-1 gap-3">
        {features.map((feat, i) => (
          <FeatureTile key={i} feat={feat} delay={i * 100} />
        ))}
      </div>
    </section>
  );
};

const FeatureTile = ({ feat, delay }) => {
  const [ref, visible] = useScrollReveal(0.1);

  return (
    <div
      ref={ref}
      className="transition-all duration-700 ease-out"
      style={{
        transitionDelay: `${delay}ms`,
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(20px)",
      }}
    >
      <div className="flex items-center gap-3 border border-[rgba(255,255,255,0.1)] rounded-xl px-5 py-8 sm:px-4 sm:py-3 hover:border-[rgba(255,245,40,0.2)] hover:bg-[rgba(255,245,40,0.03)] transition-all duration-300 cursor-default">
        <div className="text-[#FFF528] shrink-0">{feat.icon}</div>
        <span className="text-white font-[Norwester] text-md sm:text-xs uppercase tracking-wide">
          {feat.text}
        </span>
      </div>
    </div>
  );
};

export default WhyPrefer;